import { array, object, string } from 'yup';

const rolesSchema = array().of(string());

export const fcaDetailsValidations = {
  advisorFCANumber: string().required('FCA Number is required'),
  individualSelected: object().shape({
    name: string().nullable(),
    reference: string().nullable(),
    status: string().nullable(),
    roles: rolesSchema,
  }).nullable().notRequired(),
};
